import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Observable, ReplaySubject} from "rxjs";
import {HiperioChangeRegistration} from "../interface/hiperio-change-registration";

@Injectable({
  providedIn: 'root'
})
export class HiperioChangeRegistrationService {
  public readonly formListSubject: ReplaySubject<CountedAndPaginated<HiperioChangeRegistration>>
    = new ReplaySubject<CountedAndPaginated<HiperioChangeRegistration>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/hiperio/hiperio-registration-config?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<HiperioChangeRegistration>) => {
        this.formListSubject.next(result);
      });
  }

  updateStatus(uuid: string, status: number): Observable<any> {
    return this.httpClient.post(`/rest/crm/hiperio/hiperio-registration-config/${uuid}/status-update`,
      {
        status: status,
      })
      .pipe(take(1));
  }

}
